import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Bouton « Retour » intra-application.
 * - S'il existe un historique interne (navigation depuis une autre page de l'app),
 *   revient à la page précédente (navigate(-1)).
 * - Sinon (accès direct / arrivée depuis Google), redirige vers `to` pour éviter
 *   de sortir de l'application.
 */
export function BackButton({ to = "/", label = "Retour", className = "" }) {
  const nav = useNavigate();
  const loc = useLocation();

  const handleBack = () => {
    if (loc.key && loc.key !== "default") {
      nav(-1);
    } else {
      nav(to);
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-[#1F4032]/70 hover:text-[#1F4032] transition-colors mb-4 group ${className}`}
      data-testid="back-button"
      aria-label={label}
    >
      <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
      {label}
    </button>
  );
}

export default BackButton;
